import React, { Component } from "react";
import * as CONSTANT from "../../../../constants";

class RightPanel extends Component {
  render() {
    return (
      <div>
        <button id="menu-toggle-right" className="toggle" onClick={this.props.rightPanelClicked} />
        <div id="sidebar-wrapper-right" className={this.props.rightside ? "active" : ""}>
          <div className="sidebar_header">
            <h3>{this.props.selectedVideo.ImageHeader}</h3>
            <button id="menu-close-right" className="toggle" onClick={this.props.closeClicked} />
          </div>
          <div className="clearfix" />
          <div className="right_menu_container">
            <img src={CONSTANT.API_BASE_URL + this.props.selectedVideo.IntroImagePath} alt="introimage" />
          </div>
        </div>
      </div>
    );
  }
}

export default RightPanel;



// WEBPACK FOOTER //
// ./src/containers/User/Common/VideoMain/RightPanel.js